require('/opt/odin/app/frontend/components/menu_bar_float/index.module.scss');module.exports = "../../app/cells/components/menu_bar_float/show.erb";